import Article from "@components/ArticleComponent/Article";
import ArticlesContainer from "@components/ArticlesContainer/Articles.component";
import SEO from "@components/SEO/SEO.component";
import Spacer from "@components/Spacer/Spacer.component";
import { Route, Routes } from "react-router-dom";

const ArticlePage = () => {
    return (
        <main>
            <Routes>
                <Route
                    path="/"
                    element={
                        <SEO
                            title="Artykuły: Czasopismo Zdrowe Dziecko"
                            description="Strona z artykułami czasopisma Zdrowe Dziecko"
                        >
                            <Spacer>
                                <h2>Artykuły</h2>
                            </Spacer>
                            <ArticlesContainer />
                        </SEO>
                    }
                />
                <Route path="/:slug" element={<Article />} />
            </Routes>
        </main>
    );
};

export default ArticlePage;
